// extracted by mini-css-extract-plugin
module.exports = {"panel":"_d7898a6"};